var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.756,
    height: 19.985,
    viewBox: "0 0 21.756 19.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_238",
    "data-name": "Trazado 238",
    d: "M10.628,0C4.758,0,0,4.362,0,9.742s4.758,9.742,10.628,9.742,10.628-4.362,10.628-9.742S16.495.006,10.628,0Z",
    fill: "#af2d2d",
    stroke: "#ae2d2d",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_239",
    "data-name": "Trazado 239",
    d: "M142.223,132.518a.365.365,0,0,0-.485,0l-4.364,4-4.364-4a.365.365,0,0,0-.485-.008.3.3,0,0,0-.008.444l.008.008,4.364,4-4.364,4a.3.3,0,0,0-.008.444.365.365,0,0,0,.485.008l.008-.008,4.364-4,4.364,4a.365.365,0,0,0,.485-.008.3.3,0,0,0,0-.437l-4.364-4,4.364-4A.3.3,0,0,0,142.223,132.518Z",
    transform: "translate(-126.747 -127.22)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.52561d5e0326681d2e26c40011b8ba25.svg";
export { ForwardRef as ReactComponent };